export default function HowItWorks() {
  const steps = [
    {
      number: 1,
      icon: 'ri-file-list-3-line',
      title: 'Submit Your Project (Free to Start)',
      description:
        "Fill out a quick form. We'll schedule a short call to understand your situation and confirm we're a good fit.",
      detail: null,
      highlight: false,
    },
    {
      number: 2,
      icon: 'ri-lock-unlock-line',
      title: 'Get Started ($500 Flat Fee)',
      description:
        'After the call, pay a one-time $500 fee to unlock the full process and our ongoing support.',
      detail: 'Most clients save significantly more than the $500 fee.',
      highlight: true,
    },
    {
      number: 3,
      icon: 'ri-team-line',
      title: 'We Gather Competitive Bids',
      description:
        'We collect 3\u20134 bids from vetted, licensed contractors (plus anyone you want included)\u2014and review each for quality and completeness.',
      detail: null,
      highlight: false,
    },
    {
      number: 4,
      icon: 'ri-checkbox-circle-line',
      title: 'Compare, Negotiate & Choose',
      description:
        'We present bids side-by-side and help you identify, negotiate, and choose the best value.',
      detail: null,
      highlight: false,
    },
  ];

  return (
    <section id="how-it-works" className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4 tracking-tight uppercase">
            How It Works
          </h2>
          <div className="w-20 h-1 bg-orange-500 mx-auto rounded-full mb-5"></div>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Your independent advocate for a confident, stress-free roofing decision.
          </p>
        </div>

        {/* Process Cards */}
        <div className="grid md:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className={`relative rounded-2xl p-6 transition-shadow hover:shadow-xl ${
                step.highlight
                  ? 'bg-emerald-50 border border-emerald-200 shadow-md'
                  : 'bg-white shadow-lg'
              }`}
              style={{
                marginTop: index % 2 === 0 ? '0' : '2rem',
              }}
            >
              {/* Number Badge */}
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 w-16 h-16 rounded-full bg-gradient-to-br from-emerald-600 to-emerald-400 flex items-center justify-center shadow-lg">
                <span className="text-white text-2xl font-bold">
                  {step.number}
                </span>
              </div>

              {/* Icon */}
              <div className="mt-12 mb-6 flex justify-center">
                <div className="w-12 h-12 flex items-center justify-center">
                  <i className={`${step.icon} text-5xl ${step.highlight ? 'text-emerald-600' : 'text-emerald-700'}`}></i>
                </div>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                {step.title}
              </h3>

              {/* Description */}
              <p className="text-sm text-gray-600 leading-relaxed mb-4 text-center">
                {step.description}
              </p>

              {/* Subtle savings line for Step 2 */}
              {step.detail && (
                <p className="text-xs italic text-emerald-600 text-center font-medium">
                  {step.detail}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Bottom Line */}
        <p className="text-center text-sm text-gray-400 mt-14 tracking-wide">
          Simple, transparent, and built to protect you from costly mistakes.
        </p>
      </div>
    </section>
  );
}
